
import { 
  Card, 
  CardHeader, 
  CardTitle, 
  CardDescription, 
  CardContent, 
  CardFooter 
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Loader2, CreditCard } from "lucide-react";
import { formatAmount } from "../utils/formatters";

interface Subscription {
  id: string;
  status: string;
  current_period_end: number;
  cancel_at_period_end: boolean;
  plan: {
    nickname: string;
    amount: number;
    currency: string;
    interval: string;
  };
}

interface CurrentSubscriptionProps {
  subscription: Subscription;
  loading: boolean;
  onManage: () => Promise<void>;
}

export default function CurrentSubscription({ 
  subscription, 
  loading, 
  onManage 
}: CurrentSubscriptionProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Current Subscription</CardTitle>
        <CardDescription>Your active subscription details</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2">
        <div className="flex items-center justify-between">
          <span className="font-medium">Plan:</span>
          <span>{subscription.plan.nickname || 'Premium Plan'}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="font-medium">Status:</span>
          <Badge variant={subscription.status === 'active' ? 'default' : 'outline'}>
            {subscription.status.charAt(0).toUpperCase() + subscription.status.slice(1)}
          </Badge>
        </div>
        <div className="flex items-center justify-between">
          <span className="font-medium">Renewal Date:</span>
          <span>{new Date(subscription.current_period_end * 1000).toLocaleDateString()}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="font-medium">Amount:</span>
          <span>
            {formatAmount(subscription.plan.amount, subscription.plan.currency)} / {subscription.plan.interval}
          </span>
        </div>
        <div className="flex items-center justify-between">
          <span className="font-medium">Auto Renewal:</span>
          <span>{subscription.cancel_at_period_end ? 'Off' : 'On'}</span>
        </div>
      </CardContent>
      <CardFooter>
        <Button 
          className="w-full" 
          onClick={onManage}
          disabled={loading}
        >
          {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <CreditCard className="mr-2 h-4 w-4" />}
          Manage Subscription
        </Button>
      </CardFooter>
    </Card>
  );
}
